export default {
  header: 'Dichtheid',
  og: 'OG',
  sg: 'SG',
  fg: 'FG',
};
